import { statics } from 'modules/common';
import { domain } from 'modules/data';
import { compareByCodeAndIsCrypto } from 'pages/requestForm/containers/xero/dataProviders/RequestCurrenciesDataProvider/RequestCurrenciesDataProvider.helpers';

/**
 * Maps currencies to select items.
 * Sorts currencies by code and isCrypto.
 * Adds the subName under code in the select item.
 */
export const mapCurrenciesToSelectItems = (currencies: domain.Currency[] = []) => {
    return currencies.sort(compareByCodeAndIsCrypto).map((currency) => {
        const code = currency.code.toLocaleLowerCase();
        const subNameText = currency.isCrypto
            ? statics.currency.findCryptoCurrencyByCode(code)?.text
            : statics.currency.findCurrencyByCode(code)?.text;
        const subName = subNameText?.replace(RegExp(`^${currency.code} `), '') || code;

        return {
            id: currency.code,
            text: currency.code,
            subName,
        };
    });
};
